import React, { useEffect } from 'react';
import { Button, Col, Container, FormGroup, Label, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import renderField from '../../../shared/components/custom/Field';
import renderDropZoneFieldNew from '../../../shared/components/form/DropZoneNew';
import { partial } from '../../../util/translation/translation';
import FormBox from '../../../shared/components/custom/FormBox';

const s = partial('shared');
const p = partial('ProfileForm');

const ProfileForm = ({ handleSubmit, initialize, profile, clubConfig }) => {
  useEffect(() => {
    if (profile) {
      initialize({
        ...profile,
        ...(clubConfig?.config?.socials ? clubConfig.config.socials : {}),
        imageUrl: profile.imageUrl
          ? [{ src: profile.imageUrl, value: profile.imageUrl }]
          : undefined,
      });
    }
  }, [profile]);

  return (
    <form onSubmit={handleSubmit} className="form">
      <Container>
        <FormBox
          title={`${p('organization')}*`}
          style={{ marginBottom: 15, paddingBottom: 8 }}
        >
          <FormGroup className="m-2" row>
            <Col md={6}>
              <Label htmlFor="contactMail">{p('contactMail')}</Label>
              <Field name="contactMail" component={renderField} type="text" />
            </Col>
            <Col md={6}>
              <Label htmlFor="contactPhone">{p('contactPhone')}</Label>
              <Field name="contactPhone" component={renderField} type="text" />
            </Col>
          </FormGroup>
          <FormGroup className="m-1" row>
            <Col md={6}>
              <Label htmlFor="homepage">{p('homePage')}</Label>
              <Field name="homepage" component={renderField} type="text" />
              <Label htmlFor="address">{p('address')}</Label>
              <Field name="address" component={renderField} type="text" />
              <Label htmlFor="orgNr">{p('orgNr')}</Label>
              <Field name="orgNr" component={renderField} type="text" />
            </Col>
            <Col md={6}>
              <Label htmlFor="imageUrl">{s('logo')}</Label>
              <Field name="imageUrl" component={renderDropZoneFieldNew} />
            </Col>
          </FormGroup>
        </FormBox>
        <FormBox
          title={p('some')}
          style={{ marginBottom: 15, paddingBottom: 8 }}
        >
          <Col>
            <Label htmlFor="facebook">{p('facebook')}</Label>
            <Field name="facebook" component={renderField} type="text" />
          </Col>
          <Col>
            <Label htmlFor="instagram">{p('instagram')}</Label>
            <Field name="instagram" component={renderField} type="text" />
          </Col>
          <Col>
            <Label htmlFor="twitter">{p('twitter')}</Label>
            <Field name="twitter" component={renderField} type="text" />
          </Col>
          <Col>
            <Label htmlFor="youtube">{p('youtube')}</Label>
            <Field name="youtube" component={renderField} type="text" />
          </Col>
          <Col>
            <Label htmlFor="tiktok">{p('tiktok')}</Label>
            <Field name="tiktok" component={renderField} type="text" />
          </Col>
          <Col>
            <Label htmlFor="linkedin">{p('linkedin')}</Label>
            <Field name="linkedin" component={renderField} type="text" />
          </Col>
        </FormBox>
        <Row>
          <Button color="success" type="submit">
            {s('edit')}
          </Button>
          <Link to="/settings">
            <Button color="secondary">{s('close')}</Button>
          </Link>
        </Row>
      </Container>
    </form>
  );
};

const rf = reduxForm({
  form: 'profileForm',
});

export default rf(ProfileForm);
